import { setLocalePath } from "@/locales/index";
export const locale_file_path = "views.store_work_process.";
/**
 * 언어팩 경로 셋팅 메서드
 * @param appendPath 추가로 붙일 경로 문자열
 * @returns
 */
export const autoLcStoreWorkProcess = (appendPath = "") => setLocalePath(locale_file_path + appendPath);
export default {
    page_title: "상점 업무처리",
    description: "가맹점과 소속 총판/지사간의 업무처리 내용입니다.",
    create: "신규 등록",
    is_important: "중요",
    is_important_on: "중요",
    is_important_off: "",
    edit: "수정",
    delete: "삭제",
    deleted_item: "삭제된 글입니다.",
    detail_view: "상세보기 (No. {id})",
    user_name: "작성자",
    target_store: "대상 상점",
    target_dist_all_store: "총판 전체 상점",
    target_hub_all_store: "허브 전체 상점",
    table: {
        id: "번호",
        title: "제목",
        user_name: "작성자",
        created_time: "등록일",
        edit: "수정",
    },
    placeholder: {
        title: "제목을 입력해 주세요.",
        select_store: "상점을 선택해 주세요.",
        body: "내용을 입력해 주세요.",
    },
    form: {
        author: "작성자",
        target: "대상",
        body: "내용",
        origin_body: "원본 내용",
    },
};
